import React, { useCallback } from 'react';

import { QuickFindSkeleton as QuickFindSkeletonInternal } from '@atlassian/search-page/quick-find-skeleton';

import { LoadableAfterPaint } from '@confluence/loadable';
import { useRouteActions } from '@confluence/route-manager/entry-points/RouteState';
import { CONTEXT_PATH } from '@confluence/named-routes/entry-points/context';
import { useIsNav4Enabled } from '@confluence/nav4-enabled/entry-points/useIsNav4Enabled';

import { getPersistedGhostText } from './utils/getPersistedGhostText';
import { fg } from '@confluence/feature-gating';

export const QuickFindSkeleton = () => {
	const { push } = useRouteActions();
	const isNav4Enabled = useIsNav4Enabled();
	const onEnter = useCallback(
		(e: React.KeyboardEvent) => {
			const input = e.target as HTMLInputElement;
			input.blur();
			push(`${CONTEXT_PATH}/search/?text=${input.value}`);
		},
		[push],
	);

	// Get persisted ghost text for the skeleton placeholder
	const customPlaceholder = fg('quickfind-ghosttext') ? getPersistedGhostText() : undefined;

	return (
		<QuickFindSkeletonInternal
			onEnter={onEnter}
			isNav4Enabled={isNav4Enabled}
			customPlaceholder={customPlaceholder}
		/>
	);
};

export const QuickFindAsync = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-QuickFind" */ './QuickFind')).QuickFind,
	loading: () => <QuickFindSkeleton />,
});
